export const useInputBox = ({ setvalue }) => {
  const setInputValue = (e) => setvalue(e.target.value);
  return {
    setInputValue,
  };
};
